/* =========================================================================
   FEBELVN core utilities  —  SMART CART MODE

   The theme no longer ships a cart drawer. Shiprocket Smart Cart owns the
   cart completely. This file gives the rest of the theme:

     FV.lockScroll() / FV.unlockScroll()  — one owner for the body scroll lock
     FV.addToCart(variantId, qty, button) — the ONLY way theme code adds items
     FV.openCart()                        — opens Smart Cart, safely
     FV.loadSwiper() / FV.loadScript()    — load libraries once, on demand

   Nothing in the theme may intercept a cart click or a cart form any more.
   That is Smart Cart's job, and two systems doing it is what broke the cart.
   ========================================================================= */
(function () {
  if (window.FV) return;

  var FV = {};

  /* ======================================================================
     1. Body scroll lock
     Four components used to lock scroll with two incompatible mechanisms
     (body.classList vs body.style.overflow), so they unlocked each other
     and left mobile frozen. Everything goes through this counter now.
     Smart Cart manages its own lock — do not call these for the cart.
     ====================================================================== */
  var locks = 0;

  function applyLock() {
    if (locks > 0) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
      document.body.style.overflow = '';
      document.body.style.position = '';
    }
  }

  FV.lockScroll = function () { locks++; applyLock(); };
  FV.unlockScroll = function () { locks = locks > 0 ? locks - 1 : 0; applyLock(); };
  FV.resetScroll = function () { locks = 0; applyLock(); };

  /* Safety nets so the page can never be left frozen */
  window.addEventListener('pageshow', FV.resetScroll);
  window.addEventListener('popstate', FV.resetScroll);
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' || e.code === 'Escape') FV.resetScroll();
  });

  /* ======================================================================
     2. Cart bridge to Shiprocket Smart Cart

     Smart Cart hooks the cart icon and watches cart AJAX calls. Theme code
     must therefore do exactly two things: add via /cart/add.js, then ask
     for the cart to open. openCart() first checks whether Smart Cart has
     already opened itself — otherwise clicking the icon would toggle it
     shut again.
     ====================================================================== */

  /* Selectors that identify an OPEN Smart Cart panel.
     If the drawer ever double-toggles, inspect the open drawer in DevTools,
     copy its outermost class or id, and add it to this list. */
  var CART_PANEL_SELECTORS = [
    '[class*="smart-cart"]',
    '[id*="smart-cart"]',
    '[id*="smartCart"]',
    '[class*="sr-cart"]',
    '[id*="srCart"]',
    '[class*="shiprocket-cart"]',
    '[data-sr-cart]'
  ].join(',');

  function cartPanelIsOpen() {
    var nodes;
    try { nodes = document.querySelectorAll(CART_PANEL_SELECTORS); }
    catch (e) { return false; }

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var rect = el.getBoundingClientRect();
      if (rect.width < 150 || rect.height < 200) continue;
      if (rect.right <= 0 || rect.left >= window.innerWidth) continue;
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.1) continue;
      return true;
    }
    return false;
  }
  FV.cartIsOpen = cartPanelIsOpen;

  FV.openCart = function () {
    /* Give Smart Cart a moment to open itself off the back of the add */
    setTimeout(function () {
      if (cartPanelIsOpen()) return;
      var icon = document.getElementById('cart-icon-bubble') ||
                 document.querySelector('a[href$="/cart"]');
      if (icon) icon.click();
      else window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
    }, 450);
  };

  /* Keep the header count in sync without a full page render */
  FV.refreshCartCount = function () {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var link = document.getElementById('cart-icon-bubble');
        if (!link) return cart;
        var bubble = link.querySelector('.cart-count-bubble');
        if (!bubble && cart.item_count > 0) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
          link.appendChild(bubble);
        }
        if (bubble) {
          var n = bubble.querySelector('span[aria-hidden]');
          var sr = bubble.querySelector('.visually-hidden');
          if (n) n.textContent = cart.item_count;
          if (sr) sr.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
          bubble.style.display = cart.item_count > 0 ? '' : 'none';
          bubble.classList.remove('hidden');
        }
        return cart;
      })
      .catch(function () {});
  };

  /* The single add-to-cart path for ALL theme code */
  FV.addToCart = function (variantId, quantity, button) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var originalText = button ? button.innerHTML : null;

    if (button) {
      button.disabled = true;
      button.style.opacity = '0.65';
    }

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity || 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'Add to cart failed');
        /* Tell any listener (Smart Cart, analytics) that the cart changed */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: data }));
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'fv-core', cartData: data });
        }
        return FV.refreshCartCount().then(function () {
          FV.openCart();
          return data;
        });
      })
      .catch(function (err) {
        if (window.console) console.warn('[FV] add to cart failed:', err && err.message);
        throw err;
      })
      .then(
        function (d) { restore(); return d; },
        function (e) { restore(); throw e; }
      );

    function restore() {
      if (!button) return;
      button.disabled = false;
      button.style.opacity = '1';
      if (originalText !== null) {
        setTimeout(function () { button.innerHTML = originalText; }, 1200);
      }
    }
  };

  /* ======================================================================
     3. Swiper — one version, loaded once, on demand
     ss-circle-menu loaded v11 while homeshop-video ran a v8 config against
     whatever had already landed, styled with v9 CSS. Now: one loader.
     ====================================================================== */
  var SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  var SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  var swiperQueue = [];
  var swiperState = 0;

  FV.loadSwiper = function (callback) {
    if (window.Swiper) { swiperState = 2; callback(); return; }
    swiperQueue.push(callback);
    if (swiperState === 1) return;
    swiperState = 1;

    FV.loadStyle(SWIPER_CSS);

    var script = document.createElement('script');
    script.src = SWIPER_JS;
    script.async = true;
    script.onload = function () {
      swiperState = 2;
      var q = swiperQueue;
      swiperQueue = [];
      q.forEach(function (cb) {
        try { cb(); } catch (e) { /* one broken slider must not kill the rest */ }
      });
    };
    script.onerror = function () { swiperState = 0; swiperQueue = []; };
    document.head.appendChild(script);
  };

  var scripts = {};
  FV.loadScript = function (src, callback) {
    if (scripts[src] === 2) { callback(); return; }
    scripts[src + '__q'] = scripts[src + '__q'] || [];
    scripts[src + '__q'].push(callback);
    if (scripts[src]) return;
    scripts[src] = 1;
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.onload = function () {
      scripts[src] = 2;
      (scripts[src + '__q'] || []).forEach(function (cb) { cb(); });
      scripts[src + '__q'] = [];
    };
    document.head.appendChild(s);
  };

  FV.loadStyle = function (href) {
    if (document.querySelector('link[href="' + href + '"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    document.head.appendChild(l);
  };

  window.FV = FV;
})();
